import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const QuestionCircleFilled = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.1 13C11.1 11.9111 11.7818 11.415 12.403 10.9631C12.9227 10.585 13.4 10.2377 13.4 9.6C13.4 9 12.9 8.6 12.2 8.6C10.9 8.5 10.5 9.6 10.5 9.6L8.8 8.8C8.8 8.8 9.5 6.6 12.2 6.5C14.2 6.6 15.5 7.9 15.5 9.3C15.5 10.8376 14.7357 11.3803 14.0523 11.955C13.4997 12.4197 13 12.8399 13 13.6H11.2C11.2 13.6 11.1 13.3 11.1 13ZM13 17.5V15.5H11V17.5H13Z"
      fill="currentColor"
    />
  </Icon>
));

export default QuestionCircleFilled;
